// extracted by mini-css-extract-plugin
export default {"noData":"NoData_noData__abCPs","title":"NoData_title__DHPp5","description":"NoData_description__upA4c"};